export default "__VITE_ASSET__DJEcyi7g__"